// extracted by mini-css-extract-plugin
export default {"container":"gz-z","dimension":"hz-z","dimensionLabels":"iz-z"};